export const TIME_SLOTS = [
    '09:00', '10:00', '11:00', '12:00',
    '14:00', '15:00', '16:00', 
  ];
  
  export const SERVICE_TYPES = {
    PERSONAL_COUNSELING: 'personal-counseling',
    // VCT: 'vct',
    // CONSULTATION: 'consultation',
    COUPLE_THERAPY: 'couple-therapy',
    FAMILY_COUNSELING: 'family-counseling',
    GROUP_THERAPY: 'group-therapy'
  };
  
  export const APPOINTMENT_STATUS = {
    SCHEDULED: 'scheduled',
    COMPLETED: 'completed',
    CANCELLED: 'cancelled',
    NO_SHOW: 'no-show',
    IN_PROGRESS: 'in-progress',
    WAITLIST: 'waitlist'
  };